import React from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";
import { Link } from "react-router-dom";

function Rooms() {
  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg" />
          {/* /.page-header__bg */}
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <span>Rooms</span>
              </li>
            </ul>
            {/* /.thm-breadcrumb list-unstyled */}
            <h2 className="page-header__title">
              Rooms at Hanthana House Kandy
            </h2>
          </div>
          {/* /.container */}
        </section>
        {/* /.page-header */}
        <section className="villa-page">
          <div className="container tabs-box">
            <div className="tabs-content">
              <div className="tab active-tab" id="list">
                <div className="row gutter-y-30">
                  <div className="col-lg-12">
                    <div
                      className="villa-card-list villa-card-list--full-width wow fadeInUp"
                      data-wow-delay="100ms"
                    >
                      <div className="row d-flex align-items-center">
                        <div className="col-lg-5">
                          <div className="villa-card-list__image">
                            <img
                              src="/assets/images/rooms/peak/1.webp?v=20260924"
                              alt="villoz"
                            />
                          </div>
                          {/* /.villa-card-list__image */}
                        </div>
                        <div className="col-lg-7">
                          <div className="villa-card-list__content">
                            <p className="villa-card-list__address">
                              Two Bedroom Suite
                            </p>
                            <h3 className="villa-card-list__title">
                              <Link to="/peakroom">The Peak</Link>
                            </h3>
                            {/* /.villa-card-list__title */}
                            <ul className="list-unstyled villa-card-list__meta">
                              <li>
                                <span className="icon-bed" />2 King Size Beds
                              </li>
                              <li>
                                <span className="icon-bath" />2 Baths
                              </li>
                              <li>
                                <span className="icon-users" />4 guests
                              </li>
                            </ul>
                            {/* /.list-unstyled villa-card-list__meta */}
                          </div>
                          {/* /.villa-card-list__content */}
                        </div>
                      </div>
                    </div>
                    {/* /.villa-card-list */}
                  </div>
                  <div className="col-lg-12">
                    <div
                      className="villa-card-list villa-card-list--full-width wow fadeInUp"
                      data-wow-delay="150ms"
                    >
                      <div className="row d-flex align-items-center">
                        <div className="col-lg-5">
                          <div className="villa-card-list__image">
                            <img
                              src="/assets/images/rooms/peakfamily/1.webp?v=20260924"
                              alt="villoz"
                            />
                          </div>
                          {/* /.villa-card-list__image */}
                        </div>
                        <div className="col-lg-7">
                          <div className="villa-card-list__content">
                            <p className="villa-card-list__address">
                              Ideal for a family getaway
                            </p>
                            <h3 className="villa-card-list__title">
                              <Link to="/peakfamily">The Peak Family</Link>
                            </h3>
                            {/* /.villa-card-list__title */}
                            <ul className="list-unstyled villa-card-list__meta">
                              <li>
                                <span className="icon-bed" />2 King Size Beds
                              </li>
                              <li>
                                <span className="icon-bath" />1 Bath
                              </li>
                              <li>
                                <span className="icon-users" />4 guests
                              </li>
                            </ul>
                            {/* /.list-unstyled villa-card-list__meta */}
                          </div>
                          {/* /.villa-card-list__content */}
                        </div>
                      </div>
                    </div>
                    {/* /.villa-card-list */}
                  </div>
                  <div className="col-lg-12">
                    <div
                      className="villa-card-list villa-card-list--full-width wow fadeInUp"
                      data-wow-delay="200ms"
                    >
                      <div className="row d-flex align-items-center">
                        <div className="col-lg-5">
                          <div className="villa-card-list__image">
                            <img
                              src="/assets/images/rooms/foresttriple/2.webp?v=20260924"
                              alt="villoz"
                            />
                          </div>
                          {/* /.villa-card-list__image */}
                        </div>
                        <div className="col-lg-7">
                          <div className="villa-card-list__content">
                            <p className="villa-card-list__address">
                              Triple the Space, Triple the Comfort, Triple the
                              Fun!
                            </p>
                            <h3 className="villa-card-list__title">
                              <Link to="/foresttriple">
                                Forest View - Triple Room
                              </Link>
                            </h3>
                            {/* /.villa-card-list__title */}
                            <ul className="list-unstyled villa-card-list__meta">
                              <li>
                                <span className="icon-bed" />2 King Size Beds
                              </li>
                              <li>
                                <span className="icon-bath" />1 bath
                              </li>
                              <li>
                                <span className="icon-users" />3 guests
                              </li>
                            </ul>
                            {/* /.list-unstyled villa-card-list__meta */}
                          </div>
                          {/* /.villa-card-list__content */}
                        </div>
                      </div>
                    </div>
                    {/* /.villa-card-list */}
                  </div>
                  <div className="col-lg-12">
                    <div
                      className="villa-card-list villa-card-list--full-width wow fadeInUp"
                      data-wow-delay="250ms"
                    >
                      <div className="row d-flex align-items-center">
                        <div className="col-lg-5">
                          <div className="villa-card-list__image">
                            <img
                              src="/assets/images/rooms/forestdouble/1.webp?v=20260924"
                              alt="villoz"
                            />
                          </div>
                          {/* /.villa-card-list__image */}
                        </div>
                        <div className="col-lg-7">
                          <div className="villa-card-list__content">
                            <p className="villa-card-list__address">
                              Comfort Made for Two, Just Right for You
                            </p>
                            <h3 className="villa-card-list__title">
                              <Link to="/forestdouble">
                                Forest View - Double Room
                              </Link>
                            </h3>
                            {/* /.villa-card-list__title */}
                            <ul className="list-unstyled villa-card-list__meta">
                              <li>
                                <span className="icon-bed" />1 King Size beds
                              </li>
                              <li>
                                <span className="icon-bath" />1 bath
                              </li>
                              <li>
                                <span className="icon-users" />2 guests
                              </li>
                            </ul>
                            {/* /.list-unstyled villa-card-list__meta */}
                          </div>
                          {/* /.villa-card-list__content */}
                        </div>
                      </div>
                    </div>
                    {/* /.villa-card-list */}
                  </div>
                  <div className="col-lg-12">
                    <div
                      className="villa-card-list villa-card-list--full-width wow fadeInUp"
                      data-wow-delay="300ms"
                    >
                      <div className="row d-flex align-items-center">
                        <div className="col-lg-5">
                          <div className="villa-card-list__image">
                            <img
                              src="/assets/images/rooms/foresttwin/2.webp?v=20260924"
                              alt="villoz"
                            />
                          </div>
                          {/* /.villa-card-list__image */}
                        </div>
                        <div className="col-lg-7">
                          <div className="villa-card-list__content">
                            <p className="villa-card-list__address">
                              Shared Space, Individual Comfort
                            </p>
                            <h3 className="villa-card-list__title">
                              <Link to="/foresttwin">
                                Forest View - Twin Room
                              </Link>
                            </h3>
                            {/* /.villa-card-list__title */}
                            <ul className="list-unstyled villa-card-list__meta">
                              <li>
                                <span className="icon-bed" />2 Single Beds
                              </li>
                              <li>
                                <span className="icon-bath" />1 bath
                              </li>
                              <li>
                                <span className="icon-users" />2 guests
                              </li>
                            </ul>
                            {/* /.list-unstyled villa-card-list__meta */}
                          </div>
                          {/* /.villa-card-list__content */}
                        </div>
                      </div>
                    </div>
                    {/* /.villa-card-list */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Rooms;
